<script>
  import { ignoreCaseSort } from '../../../shared/utils/Sort.svelte'
  import {
    createProps,
    getSchemaComponent,
    getSchemaComponentProps,
    defaultValue,
    getComponent,
    getComponentProps
  } from '../helpers'
  const p = createProps([]);
  export let value = p.value;
  export let errors = p.errors;
  export let schema = p.schema;
  export let components = p.components;
  export let key = p.key;
  /* recalc a default value */
  if (schema && value === null) {
      value = defaultValue(schema, value);
  }
  let input = "";
  let autocomplete = "";
</script>

{#if components && schema && schema.items && schema.items.type}
  <svelte:component
    this={getComponent(components.wrapper)}
    {...getComponentProps(components.wrapper)}
    {schema}
    {errors}>
          <div id="{key}_autocomplete" class="form-autocomplete">
              <div class="form-autocomplete-input form-input pt-2">
                  {#if value}
                      {#each value as val, i}
                          <div class="chip">
                              {val}
                              <button on:click={(e) => {
                                  var tempArray = value;
                                  tempArray.splice(i, 1);
                                  value = tempArray;
                              }} type="button" class="btn btn-clear" aria-label="Remove"></button>
                          </div>
                      {/each}
                  {/if}
                  <input class="form-input" type="text" bind:value={input} on:focus={(e) => {
                      autocomplete = key
                  }} on:blur={(e) => {
                      window.setTimeout(function () {
                          autocomplete = ""
                      }, 200)
                  }}>
              </div>
              {#if schema.items && schema.items.enum && schema.items.enum.length > 0 && autocomplete == key}
                  <ul class="menu autocomplete-options">
                      {#each schema.items.enum.sort(ignoreCaseSort) as option}
                          {#if option.toLowerCase().startsWith(input.toLowerCase())}
                              <li class="menu-item">
                                  <button type="button" class="btn btn-link" on:click={(e) => {
                                          if (!value.includes(option)) {
                                              if (value) 
                                                  value = value.concat([option]);
                                              else
                                                  value = option;
                                              input = "";
                                          }
                                      }}>
                                      <div class="tile tile-centered">
                                      <div class="tile-content">
                                          {option}
                                      </div>
                                      </div>
                                  </button>
                              </li>
                          {/if}
                      {/each}
                  </ul>
              {/if}
          </div>
          <div class="footer-actions">
              <button type="button" class="btn btn-link btn-sm" on:click={(e) => {
                  e.currentTarget.blur();
                  value = schema.items.enum.sort(ignoreCaseSort).flatMap(function (item) {
                      return [item];
                  });
              }}>Select All</button>
              <button type="button" class="btn btn-link btn-sm" on:click={(e) => {
                  e.currentTarget.blur();
                  value = []
              }}>Clear</button>
          </div>
  </svelte:component>
{/if}

<style>
.chip {
    background-color: #00ab5f;
    color: white;
}
.footer-actions {
    width: 100%;
    background-color: #eef0f3;
    border: 0.05rem solid #bcc3ce;
    border-top: 0;
}
.form-autocomplete .menu {
  position: relative;
}
</style>
